import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const ContentContainer = styled(FlexContainer)`
  flex-direction: column;
  width: 100%;
  height: 100vh;
  padding: ${({ theme: { system } }) => `0 ${system.fds_sys_spacing_S}`};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    overflow: visible;
  }
`;

export const Terms = styled.span`
  display: block;
  text-align: center;
  font-size: 12px;
  margin-bottom: 5px;
  a {
    cursor: pointer;
    color: ${({ theme: { colors } }) => colors.green_3};
  }
`;

export const SpinnerContainer = styled(FlexContainer)`
  height: 100%;
`;
